import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OfflineAttachment } from '@app/dashboard/shared/models/offline-attachments';
import { AttachmentService } from '@app/dashboard/shared/services/attachments.service';
import { CertificateService } from '@app/dashboard/shared/services/certificate.service';
import { FileManagementService } from '@app/shared/services/file-management.service';
import { StringConstants } from '@app/shared/string-constants';
import { NotificationService } from '@progress/kendo-angular-notification';
import { downloadIcon, SVGIcon } from '@progress/kendo-svg-icons';

@Component({
	selector: 'kpa-offlinedocs',
	templateUrl: './offlinedocs.component.html',
	styleUrl: './offlinedocs.component.scss',
})
export class OfflineDocsComponent {
	@Input() dialogOpened: boolean = false;
	@Input() offlineAttachments: OfflineAttachment[];
	@Output() dialogOpenedChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() closeDialog = new EventEmitter();
	constructor(
		private fileManagementService: FileManagementService,
		private certificateService: CertificateService,
		private notificationService: NotificationService
	) {}

	public downloadIcon: SVGIcon = downloadIcon;
	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public downloadFileByFileId(attachment: OfflineAttachment) {
		if (attachment.fileId) {
			this.fileManagementService.downloadFileByFileId(attachment.fileId).subscribe({
				next: (response) => {
					this.certificateService.downloadCert(attachment.title, response);
				},
				error: (err) => {
					this.notificationService.show({
						content: 'Error while downloading document.',
						hideAfter: StringConstants.hideNotificationAfter,
						position: { horizontal: 'right', vertical: 'bottom' },
						animation: { type: 'fade', duration: 400 },
						type: { style: 'error', icon: true },
					});
				},
			});
		}
	}

	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.closeDialog.emit();
	}
}
